module.exports = __webpack_public_path__ + "static/img/9.126492d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/9.png
// module id = IJoH
// module chunks = 0